<template>
    <div>
      <a href="https://octa.vn/dang-nhap" class="button navbar-toggler">
           <span class="nav-link-inner--text button_login_menu">Đăng nhập</span>
       </a>
      <button class="navbar-toggler" type="button"
              data-toggle="collapse"
              :data-target="target"
              :aria-controls="target"
              :aria-expanded="toggled"
              aria-label="Toggle navigation">
              
          <span class="navbar-toggler-icon"></span>
          
      </button>
    </div>
</template>
<script>
export default {
  props: {
    target: {
      type: [String, Number],
      description: "Button target element"
    },
    toggled: {
      type: Boolean,
      default: false,
      description: "Whether button is toggled"
    }
  }
};
</script>
<style>
</style>
